import {GeneralPrintResponseModel, ResponseBaseModel} from "../models";
import AlYusrAxiosApiInstance from "../axios/alYusrAxiosApiInstance";
//#region get
export const PrintPdfGenericMethodCaller = async (
    url: string
): Promise<ResponseBaseModel<GeneralPrintResponseModel>> => {
    return await AlYusrAxiosApiInstance.get(url);
}
//#endregion